module.exports = __webpack_public_path__ + "d58496a41fd013985a1498abf1be4e23.ttf";